import React, { useEffect, useState, useCallback } from "react";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import { usePreviousLocation } from "../../components/withSidebar/PreviousLocationContext";
import { Editor } from "react-draft-wysiwyg";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Box, Modal } from "@mui/material";
import rejectImage from "../../assests/images/Reject.png";
import checkImage from "../../assests/images/check-circle.png";
import { UserObj } from "../../services/localStarage"; 
import { rfqServices } from "../../services/rfqServices";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom"; 
import { isEmptyDash, strToDate, strToDateYYMMDD ,urlConstants } from "../../constant";
import { EditorState, convertToRaw } from "draft-js"; 
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";  
import draftToHtml from "draftjs-to-html";
import { htmlDocs } from "../buyerPurchaseOrder/draftToHtml";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";  
import { toWords } from "number-to-words";
import Tooltip from '@mui/material/Tooltip';

const initialColumnsApprove = [
    { id: "Sr.no.", label: "Sr. No.", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "vendorsname", label: "Vendor’s Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "vendorstatus.", label: "Vendor Status", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "quotationreceived", label: "Quotation Received", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "technicallyacceptable", label: "Technically Acceptable", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  ];

  const comparisonColumn = [
    { id: "Sr.no.", label: "Sr. No.", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "vendorsname", label: "Vendor’s Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "vendorCode.", label: "Vendor Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "bidPosition", label: "Bid Positions", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "technicalRecomendation", label: "Technical Recommendation", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "initalBidAmount", label: "Initial Bid Amount", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "reverseAuctionAmount", label: "Reverse Auction Amount", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "finalNegotiate", label: "Final Negotiated Amount", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "reductionInitial", label: "Reduction (%) w.r.t. Initial", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  ];
    

  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  
function ApprovalNFA() {
     const { id } = useParams();
      let navigate = useNavigate();
       const navigateUrl = (param) => {
         navigate(param);
       };
    const [approvecolumns, setApproveColumns] = useState(initialColumnsApprove);
    const [comparisonColumns, setComparisonColumns] = useState(comparisonColumn);
    const [isLoading, setIsLoading] = useState(false);
    const [opennfaapprovelmodalupdate, setOpenNfaApprovelModalUpdate] =
    useState(false);
    const [opennfaapprovelsuccessnfa, setOpenNfaApprovelsuccessNfa] =
    useState(false);
    const [openapprovednfa, setOpenApprovedNfa] = useState(false);
    const [openapprovedsuccessnfa, setOpenApprovedSuccessNfa] = useState(false);
    const [openrejectednfa, setOpenRejectedNfa] = useState(false);
    const [openrejectednfasuccess, setOpenRejectedNfaSuccess] = useState(false); 
    const userRole = UserObj?.role?.name;
    const userID = UserObj?._id;
    const [alertComponent, setAlertComponent] = useState({
      open: false,
      message: "",
      type: "",
    });

    const onSortChange = (index, sortBy, sortOrder) => {
        let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
      }
   const [buyerApproval, setBuyerApproval] = useState(''); 
    useEffect(() => { 
      getNFADetails(id);
      getBuyerApproval();
    }, []); 

    const base64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;

    const safeAtob = (base64Str)=> {
      const binary = atob(base64Str);
      const uint8Array = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        uint8Array[i] = binary.charCodeAt(i);
      }
      const decoder = new TextDecoder();
      return decoder.decode(uint8Array);
    }

    const decodeContent = (content) => {
      if (!content) return "<p>N/A</p>";
      return base64Regex.test(content) ? safeAtob(content) : decodeURIComponent(content);
    }

    const getNFADetails = (id) => {
      setIsLoading(true); 
      rfqServices.getNFADetails(id)
        .then((res) => {
          if (res && res?.data) { 
            SetNFADetails(res?.data?.data);

            setBackgroundBidDetails({
              backgroundAndBidDetails: EditorState.createWithContent(htmlDocs(decodeContent(res?.data?.data?.backgroundAndBidDetails))),
            });


            setRecommendationDetials({
              recommendation: EditorState.createWithContent(htmlDocs(decodeContent(res?.data?.data?.recommendation))),
            });
 

          } else {
            setAlertComponent({
              open: true,
              type: 'error',
              message: 'No Data Found',
            });
          }
        })
        .catch((error) => {
          setAlertComponent({
            open: true,
            type: 'error',
            message: `${error?.response?.data?.message}`,
          }); 
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    const getBuyerApproval = () => {
      setIsLoading(true);
      let param = "?departments=PROCUREMENT";
      rfqServices
        .getAssignEngineer(param)
        .then((res) => {
          if (res && res.data) {
            setBuyerApproval(res?.data?.data);
          } else {
            setAlertComponent({
              open: true,
              type: 'error',
              message: 'No Data Found',
            });
          }
        })
        .catch((error) => {
          setAlertComponent({
            open: true,
            type: 'error',
            message: `${error?.response?.data?.message}`,
          }); 
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
    // const [getNFACommercialDetails, SetNFADetails] = useState(false);
    const [getNFACommercialDetails, SetNFADetails] = useState({
      wbsElement : "",
      l1Approver: {},
      orderValue: { amount: null, inWords: "", excluding: "" },
      benchmarkPrice: { amount: null, inWords: "", excluding: "" },
      applicableTaxes: "",
      terms: "",
      deliveryPeriod: null,
      freeIssueMaterials: "",
      paymentTerms: "",
      ldApplicable: "",
      bgApplicable: "",
      otherTnc: "",
      deviationFromTerms: "",
      backgroundAndBidDetails: "",
      recommendation: "",
      budgetHead: "",
      budgetAmount: null,
      thisProposal: null,
      balanceBudget: null,
      remarks: "", 
      project : "",
      package : "",
      location: ""
    });
    // const onDetailsInputChange = (e) => {
    //   let { name, value } = e.target;
    //   setApprNFADetails(prevData => ({ ...prevData, [name]: value }));
    // };

    // const onDetailsInputChange = (e) => {
    //   const { name, value, dataset } = e.target;
    //   const keyPath = name.split(".");
    //   SetNFADetails((prevData) => {
    //     const newData = { ...prevData };
    //     if (keyPath.length === 2) {
    //       newData[keyPath[0]][keyPath[1]] = value;
    //     } else {
    //       newData[name] = value;
    //     }
    //     return newData;
    //   });
    // }; 
    const handleL1ApprovalChange = (value) => {
      SetNFADetails((prevData) => {
        const updatedState = {
          ...prevData,
          l1Approval: {
            ...prevData.l1Approval,
            approver: value,
          },
        };
        return updatedState;
      });
    };
     const onDetailsInputChange = (e) => {
          const { name, value } = e.target; 
          const newValue = value;  
          if (name === "l1Approval.approver") {
            handleL1ApprovalChange(newValue);
            return;  
          }
          SetNFADetails((prevData) => {
            const newData = { ...prevData };  
            const keyPath = name.split(".");     
            if (keyPath.length === 2) { 
              newData[keyPath[0]][keyPath[1]] = newValue;

              if (keyPath[0] === "orderValue" && keyPath[1] === "amount") {
                newData[keyPath[0]].inWords = value ? toIndianWords(value) : "";
              }
              if (keyPath[0] === "benchmarkPrice" && keyPath[1] === "amount") {
                newData[keyPath[0]].inWords = value ? toIndianWords(value) : "";
              }
            } else {
              newData[name] = newValue;
            }  
            if (newData?.budgetAmount && newData?.thisProposal !== undefined) {
              newData.balanceBudget = newData.budgetAmount - newData.thisProposal;
            } 
            
            return newData;
          });
        };


    const handleCloseAlert = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setAlertComponent({ ...alertComponent, open: false });
    };


    const [backgroundBidDetails, setBackgroundBidDetails] = React.useState({
      backgroundAndBidDetails: EditorState.createWithContent(htmlDocs("<p></p>"))
    }); 

    const [recommendationDetials, setRecommendationDetials] = React.useState({
      recommendation: EditorState.createWithContent(htmlDocs("<p></p>"))
    }); 
     
     const onEditorStateChangeOne = (editorState) => { 
      setBackgroundBidDetails((prevState) => ({
        ...prevState,
        backgroundAndBidDetails: editorState,
      }));
    };
    
    const onEditorStateChangeTwo = (editorState) => {
      setRecommendationDetials((prevState) => ({
        ...prevState,
        recommendation: editorState,
      }));
    };

    const getEditorContentAsHtml = (editorState) => {
      if (!editorState) return "";
      const rawContentState = convertToRaw(editorState.getCurrentContent());
      return draftToHtml(rawContentState);
  };

    const [isEditable, setIsEditable] = useState(false);
    const handleEditClick = () => {
      setIsEditable(true);  
    };
  const [negotiateAmount , setNegotiateAmount] = useState();
 

  const calculatePercentageDifference = (vendorId, finalNegotiatedAmount, originalAmount) => {
    const updatedNegotiatedAmount = parseFloat(finalNegotiatedAmount) || 0;
    const updatedPercentageDifference =
      originalAmount > 0
        ? (((updatedNegotiatedAmount - originalAmount) * 100) / originalAmount).toFixed(2)
        : "N/A";
  
    // Update negotiateAmount for specific vendor
    setNegotiateAmount((prevState) => ({
      ...prevState,
      [vendorId]: updatedPercentageDifference,
    }));
  
    // Update vendor-specific data in NFADetails
    SetNFADetails((prevState) => {
      const updatedVendors = prevState.rfqVendors.map((vendor) => {
        if (vendor.vendorId === vendorId) {
          return {
            ...vendor,
            finalNegotiatedAmount: updatedNegotiatedAmount,
          };
        }
        return vendor;
      });
      return { ...prevState, rfqVendors: updatedVendors };
    });
  };

  const safeBtoa = (str) => {
     return btoa(unescape(encodeURIComponent(str)));
      // return btoa(str);
    }

  const handleSubmit = () => {  
         if(isEmptyDash(getNFACommercialDetails?.l1Approval?.approver)){
            setAlertComponent({ open: true,  type: 'error', message: "Please Select Approver Name"}); 
            return false;
          }
          if(isEmptyDash(getNFACommercialDetails?.vendor)){
            setAlertComponent({ open: true,  type: 'error', message: "Please Select Order recommended on (Party)"}); 
            return false;
          }
          if(isEmptyDash(getNFACommercialDetails?.orderValue?.amount)){
            setAlertComponent({ open: true,  type: 'error', message: "Please Enter Order Value"}); 
            return false;
          }
    setIsLoading(true);
    const vendorData = getNFACommercialDetails?.rfqVendors?.map((vendor) => ({
      vendorId: vendor.vendorId,
      finalNegotiatedAmount: vendor?.finalNegotiatedAmount,
    })); 
    const submissionData = { 
      l1Approver:getNFACommercialDetails?.l1Approval?.approver,
      vendor : getNFACommercialDetails?.vendor ,
      subject : getNFACommercialDetails?.subject ,
      wbsElement:getNFACommercialDetails?.wbsElement,
      orderValue: {
        amount: parseFloat(getNFACommercialDetails?.orderValue?.amount),
        inWords: getNFACommercialDetails?.orderValue?.inWords,
        excluding: getNFACommercialDetails?.orderValue?.excluding,
      },
      benchmarkPrice: {
        amount: parseFloat(getNFACommercialDetails.benchmarkPrice?.amount),
        inWords: getNFACommercialDetails?.benchmarkPrice?.inWords,
        excluding: getNFACommercialDetails?.benchmarkPrice?.excluding,
      },
      applicableTaxes: getNFACommercialDetails?.applicableTaxes,
      terms: getNFACommercialDetails?.terms,
      deliveryPeriod: (getNFACommercialDetails?.deliveryPeriod) ? getNFACommercialDetails?.deliveryPeriod : null,
      freeIssueMaterials: getNFACommercialDetails?.freeIssueMaterials,
      paymentTerms: getNFACommercialDetails?.paymentTerms,
      ldApplicable: getNFACommercialDetails?.ldApplicable,
      bgApplicable: getNFACommercialDetails?.bgApplicable,
      otherTnc: getNFACommercialDetails?.otherTnc,
      deviationFromTerms: getNFACommercialDetails?.deviationFromTerms,

      backgroundAndBidDetails: safeBtoa(draftToHtml(convertToRaw(backgroundBidDetails?.backgroundAndBidDetails?.getCurrentContent()))) ,
      recommendation: safeBtoa(draftToHtml(convertToRaw(recommendationDetials?.recommendation?.getCurrentContent()))) ,

      budgetHead: getNFACommercialDetails?.budgetHead,
      budgetAmount: getNFACommercialDetails?.budgetAmount,
      thisProposal: getNFACommercialDetails?.thisProposal,
      balanceBudget: getNFACommercialDetails?.balanceBudget,
      remarks: getNFACommercialDetails?.remarks,
      project: getNFACommercialDetails?.project,
      package: getNFACommercialDetails?.package,
      location: getNFACommercialDetails?.location,
      vendorData:vendorData
    };  
    setIsLoading(true); 
    rfqServices
      .updateNfa(id , submissionData)
      .then((res) => {
        if (res && res.data) { 
          setOpenNfaApprovelsuccessNfa(true); 
        } else {
          setAlertComponent({
            open: true,
            type: 'error',
            message: res?.data?.message,
          });
        }
      })
      .catch((error) => {
        setAlertComponent({
          open: true,
          type: 'error',
          message: `${error?.response?.data?.message}`,
        }); 
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
   
  const redirectList = () => { 
    navigateUrl('/admin/Engineering-Bidding-Rfq-Listing'); 
      window.location.reload();
  }
  const redirNFA = () => {
    setOpenNfaApprovelsuccessNfa(false);
    navigateUrl('/admin/Engineering-Bidding-Rfq-Listing'); 
      window.location.reload();
  }
  const[actionStatus, setActionStatus] = useState('');
  const [remarks, setRemarks] = useState("");  

const handleRemarksChange = (e) => {
  setRemarks(e.target.value);  
};

  const handleApproveSubmit = (status) =>{
    setIsLoading(true); 
    const submissionApproveData ={
      "nfaId": id,
      "action": status,
      "remarks" : remarks 
    }  
    rfqServices
      .updateNfaApprove(submissionApproveData)
      .then((res) => {
        if (res && res.data) { 
          setOpenApprovedSuccessNfa(true); 
          setActionStatus(status);
        } else {
          setAlertComponent({
            open: true,
            type: 'error',
            message: res?.data?.message,
          });
        }
      })
      .catch((error) => {
        setAlertComponent({
          open: true,
          type: 'error',
          message: `${error?.response?.data?.message}`,
        }); 
      })
      .finally(() => {
        setIsLoading(false);
      });
  }
  const [isEditorEditable1, setIsEditorEditable1] = useState(false);

  const handleEditBackgroundClick1 = () => { 
    if (getNFACommercialDetails?.l1Approval?.approver === userID || getNFACommercialDetails?.l2Approval?.approver === userID) {
      setIsEditorEditable1(true);  
      setShowRecomButtons(true);
      getEditorClass(userRole, isEditable, isEditorEditable1 , "recom");
    }
  };
  const downloadNFAReport = (param) => {
    setIsLoading(true);
    let bodyData = {
      "nfaId": id, 
    } 

    let url = `${urlConstants.BASE_URI_DEV}/v1/internal/nfas/download`;
    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${UserObj?.accessToken}`);
    myHeaders.append("Content-Type", "application/json");
    let raw = JSON.stringify(bodyData);

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(url, requestOptions)
      .then(response => response.blob())
      .then(blob => {
        const link = window.document.createElement('a');
        link.href = URL.createObjectURL(blob);
        let fileName = `NFA_${getNFACommercialDetails?.rfqNumber}_Report`; 
        link.download = fileName;
        window.document.body.appendChild(link);
        link.click();
        window.document.body.removeChild(link);  
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}`, });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }
     
  const [showButtons, setShowButtons] = useState(false);
  const [showRecomButtons, setShowRecomButtons] = useState(false);

  const updateBidDetails = (data) => {
    setIsLoading(true); 
    const vendorData = getNFACommercialDetails?.rfqVendors?.map((vendor) => ({
      vendorId: vendor.vendorId,
      finalNegotiatedAmount: vendor?.finalNegotiatedAmount,
    }));

     
    const submissionData = {
      // vendorData : vendorData,
      backgroundAndBidDetails: safeBtoa(draftToHtml(convertToRaw(backgroundBidDetails?.backgroundAndBidDetails?.getCurrentContent()))) ,
      recommendation: safeBtoa(draftToHtml(convertToRaw(recommendationDetials?.recommendation?.getCurrentContent())))
    }
    rfqServices
      .updateNfa(id , submissionData)
      .then((res) => {
        if (res && res.data) { 
          //setOpenNfaApprovelsuccessNfa(true); 
          setAlertComponent({
            open: true,
            type: 'success',
            message: res?.data?.message,
          });
          window.location.reload();
        } else {
          setAlertComponent({
            open: true,
            type: 'error',
            message: res?.data?.message,
          });
        }
      })
      .catch((error) => {
        setAlertComponent({
          open: true,
          type: 'error',
          message: `${error?.response?.data?.message}`,
        }); 
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const [isEditorEditable, setIsEditorEditable] = useState(false);
  const [isEditorEditClass, setIsEditClass] = useState(false);

  const handleEditBackgroundClick = () => { 
    if (getNFACommercialDetails?.l1Approval?.approver === userID || getNFACommercialDetails?.l2Approval?.approver === userID) {
      setIsEditorEditable(true);  
      setShowButtons(true);
      getEditorClass(userRole, isEditable, isEditorEditable1 , "bid");
    }
  };

  const handleCancelBackgroundClick = () =>{
      setIsEditorEditable(false);  
      setShowButtons(false);
      setBackgroundBidDetails({backgroundAndBidDetails: EditorState.createWithContent(htmlDocs(getNFACommercialDetails?.backgroundAndBidDetails))});
  }

  const handleCancelRecomdationClick = ()=>{
    setIsEditorEditable1(false);  
    setShowRecomButtons(false);
    setRecommendationDetials({recommendation: EditorState.createWithContent(htmlDocs(getNFACommercialDetails.recommendation))});
  }
  const getEditorClass = (userRole, isEditable, isEditorEditable1 , type) => { 
    if (userRole === "MANAGER" && type === "recom") {
      return !isEditorEditable1 ? 'editorDisabled' : 'editorEnabled';
    } else if (userRole === "MANAGER" && type === "bid"){
      return setIsEditClass('editorEnabled');
    }
    return '';
  };

  const toIndianWords = (num) => {
        const words = toWords(num);  
        const capitalizeWords = (str) => {
          return str
            .split(' ')  
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))  
            .join(' ');  
        };
      
        // Convert large numbers to Indian system (Lakh, Crore, etc.)
        const convertToIndianFormat = (number) => {
          let result = '';
      
          // Handle cases for crore, lakh, thousand, etc.
          if (number >= 10000000) {
            const crore = Math.floor(number / 10000000);
            result += toWords(crore) + " crore ";
            number %= 10000000;
          }
      
          if (number >= 100000) {
            const lakh = Math.floor(number / 100000);
            result += toWords(lakh) + " lakh ";
            number %= 100000;
          }
      
          if (number >= 1000) {
            const thousand = Math.floor(number / 1000);
            result += toWords(thousand) + " thousand ";
            number %= 1000;
          }
      
          if (number > 0) {
            result += toWords(number);
          }
      
          return result.trim();
        };
      
        // Capitalize the first letter of each word in the result
        const indianFormattedWords = convertToIndianFormat(num);
        return capitalizeWords(indianFormattedWords);
      };

  return (
  <>
     <div className="login-forms">
     <div className="text-centers">
     <div className="approve_maine_row_body1">
                <div className="modal_row_noteapprove">
                    <div className="first_colume">
                      <p className="first_text">Note for Approval</p>
                    </div>
                   <div className="section_nfa"> 
                    <button className="btn btn-success" onClick ={downloadNFAReport}><FileDownloadOutlinedIcon/>Download</button> 

                    {(userRole === "BUYER" && getNFACommercialDetails?.l1Approval?.status === 'Pending') && (
                    <button className="btn btn-secondary"   onClick={handleEditClick}><EditOutlinedIcon />Edit</button>
                    )  }

                   </div>
                </div>

                <div className="modal_row_noteapprove">
                    <div className="note_approvel">
                      <p className="ref_approvel">Ref. No</p>
                      <p className="rfq_number_note">: {getNFACommercialDetails?.rfqNumber}</p>
                    </div>
                    <div className="note_approvel">
                      <p className="ref_approvel">Request Date</p>
                      <p className="rfq_number_note">:{strToDate(getNFACommercialDetails?.createdAt)}</p>
                    </div>
                </div>
                {/* <div className="modal_row_noteapproved_maine">
                    <div className="note_approvel">
                      <p className="ref_approvel">No. of pages</p>
                      <p className="rfq_number_note">: 23</p>
                    </div>
                </div> */}
                    <div className="modal_row_noteapproved_maine">
                      <div className="note_approvel"> 
                        {(getNFACommercialDetails?.l1Approval?.status !== 'Pending' ) && (
                          <button
                          // onClick={setOpenApprovedNfa}
                          className={`btn ${getNFACommercialDetails?.l1Approval?.status === 'Approved' ? 'btn-success' : 'btn-danger'}`}
                        >
                            L1 {getNFACommercialDetails?.l1Approval?.status}
                          </button>
                            )
                          }
                            {(getNFACommercialDetails?.l2Approval?.status !== 'Pending' ) && (
                          <button
                          // onClick={setOpenApprovedNfa}
                          className={`btn ${getNFACommercialDetails?.l2Approval?.status === 'Approved' ? 'btn-success' : 'btn-danger'}`}
                        >
                            L2 {getNFACommercialDetails?.l2Approval?.status}
                          </button>
                            )
                          }
                        </div>
                      </div>


                { (getNFACommercialDetails?.l1Approval?.approver === userID && getNFACommercialDetails?.l1Approval?.status === 'Pending') || (getNFACommercialDetails?.l2Approval?.approver === userID && getNFACommercialDetails?.l2Approval?.status === 'Pending' && getNFACommercialDetails?.l1Approval?.status !== 'Rejected') ? (
                  <div className="modal_row_noteapproved_maine">
                      <div className="note_approvel"> 
                          <>
                            <button onClick={setOpenApprovedNfa} className="btn btn-success">
                              Approve
                            </button>
                            <button onClick={setOpenRejectedNfa} className="btn btn-danger">
                              Reject
                            </button>
                          </>  
                      </div>
                  </div>
                ) : null }

                <div className="row1_nfa_danger_solar">
                  <div className="tabs_note_approvel_body">
                    <p className="project_text">
                      Project Name</p> 
                      <input type="text" className="form-control note_inpur" placeholder="" name="project" onChange={onDetailsInputChange} value={getNFACommercialDetails?.project} disabled={!isEditable}  /> 
                  </div>
                  <div className="tabs_note_approvel_body">
                    <p className="project_text">
                    Location</p>
                    <input type="text" className="form-control note_inpur" placeholder="" name="location" onChange={onDetailsInputChange} value={getNFACommercialDetails?.location} disabled={!isEditable}  /> 
                  </div>
                  <div className="tabs_note_approvel_body">
                    <p className="project_text">
                    Package </p>
                    <input type="text" className="form-control note_inpur" placeholder="" name="package" onChange={onDetailsInputChange} value={getNFACommercialDetails?.package} disabled={!isEditable}  /> 
                  </div>
                  <div className="tabs_note_approvel_body">
                    <p className="project_text">
                    WBS Element</p>
                      <input type="text" className="form-control note_inpur" placeholder="" name="wbsElement" onChange={onDetailsInputChange} value={getNFACommercialDetails?.wbsElement}  disabled={!isEditable} />
                  </div>
                  <div className="tabs_note_approvel_body">
                    <p className="project_text">
                    Approve Name</p>
                    <td>
                      <select className="form-select w-100 lets_onboarding_wizard_react" aria-label="Default select example" name="l1Approval.approver" onChange={onDetailsInputChange}  disabled={!isEditable} value={getNFACommercialDetails?.l1Approval?.approver}>

                        <option value={""} disabled>Select Approval Name</option> 

                        {buyerApproval?.assignees?.map((ele, i) => (
                          <>
                            <option key={ele?._id} value={ele?._id}>
                              {ele?.name}
                            </option>
                          </>
                        ))} 
                        </select>
                    </td>
                  </div>    
                  </div>
                  <div className="row_maine_block_uinpit">
                    <div className="maine_box1_tabs">
                      <div className="inssue_bodyy maine_issue_colume">
                          <p className="text_project_final">Subject:</p>
                          <p className="date_text"><input type="text" class="form-control form-hanfa" placeholder="" value={getNFACommercialDetails?.subject}  name="subject" onChange={onDetailsInputChange}  disabled={!isEditable} /></p>
                        </div>
                      <div className="inssue_bodyy maine_issue_colume">
                        <p className="text_project_final">Issued On :</p>
                        <p className="date_text">{strToDate(getNFACommercialDetails?.rfqPublishDate)}</p>
                      </div>
                      {/* <div className="inssue_bodyy maine_issue_colume">
                        <p className="text_project_final">Publish date :</p>
                        <p className="date_text">{strToDate(getNFACommercialDetails?.rfqPublishDate)}</p>
                      </div> */}
                      <div className="inssue_bodyy maine_issue_colume">
                        <p className="text_project_final">Final Bid Due Date :</p>
                        <p className="date_text">{strToDate(getNFACommercialDetails?.finalBidDueDate)}</p>
                      </div>
                      {/* <div className="maine_issue_colume">
                        <p className="text_project_final">System End Date :</p>
                        <p className="date_text">05-12-2024</p>
                      </div> */}
                    </div>
                  </div>

                  <div className="bidding_detail_approved">
                    <div className="detail_bidding_nfa">
                      <h5 className="detail_nfe">A. Bidding Details</h5>
                    </div>
                  <div className="listing_main listing_main_dragdropcontext_body" style={{marginBottom:"20px"}}>
                      <table className="">
                        <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                          <tr>
                            {approvecolumns.map((approvecolumns, index) => (<>
                              <th className="vendor_tabels ">
                                <div className="PoDetailTableHeading">
                                  <div className="d-flex">
                                    <p>{approvecolumns?.label}</p>
                                    {(approvecolumns.isSort == true) && <span onClick={(e) => onSortChange(index, approvecolumns.id, approvecolumns.sortLabel)} className="table-sort-ico">
                                      {(approvecolumns.sortLabel != "asc") && <img src={topArrow} />}
                                      {(approvecolumns.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                      {(approvecolumns.sortLabel != "desc") && <img src={bottomArrow} />}
                                      {(approvecolumns.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                    </span>}
                                  </div>
                                </div>
                              </th>
                            </>))}
                          </tr>
                        </thead>
                      <tbody style={{ overflowY: "scroll", width: "200px" }}>
                        {getNFACommercialDetails.length < 1 && <>
                          <tr>
                            <td colSpan={8} className="text-center list-no-data">No Data Found</td>
                          </tr>
                        </>}
                        {getNFACommercialDetails?.rfqVendors?.map((vendorData, i) => (<>
                          <tr className="maine_tr_vendor">
                            <td>{i+1}</td>
                            <td>{vendorData?.vendorName}</td>
                            <td>{vendorData?.category}</td>
                            <td>{vendorData?.participationStatus === "Submitted" ? "Yes" : "No"}</td>
                            <td>{(vendorData.technicalStatus === "NA" || vendorData.technicalStatus === "Pending" ) ? "NA" : vendorData.technicalStatus === "Approved" ? "Yes"  : "No"}</td>
                          </tr>
                        </>))} 
                      </tbody>
                    </table>
                  </div>


                <div className="detail_bidding_nfa">
                   <h5 className="detail_nfe">B. Order Details</h5>
                </div> 
            <div className="listing_main listing_main_dragdropcontext_body">
              <table>
                <thead>
                  <tr>
                    <th>Perticularls</th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Order recommended on (Party)</td>
                    <td>
                    <select className="form-select w-100 lets_onboarding_wizard_react" aria-label="Default select example" name="vendor" onChange={onDetailsInputChange} value={getNFACommercialDetails?.vendor}  disabled={!isEditable}>
                      <option value={""} disabled>Select Vendor Name</option>
                      {getNFACommercialDetails?.rfqVendors?.map((vendorData, i) => (
                         <option value={vendorData?.vendorId}>{vendorData?.vendorName}</option>
                      ))}  
                        </select>
                        </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Order Value</td>
                    <td><input type="number" class="form-control form-hanfa" placeholder="" name="orderValue.amount" value={getNFACommercialDetails?.orderValue?.amount} onChange={onDetailsInputChange} disabled={!isEditable} /></td>

                    <Tooltip title={getNFACommercialDetails?.orderValue?.inWords}> <td><input type="text" class="form-control form-hanfa" placeholder="" value={getNFACommercialDetails?.orderValue?.inWords} name="orderValue.inWords" onChange={onDetailsInputChange}  disabled={!isEditable} /></td></Tooltip>

                    <td><input type="text" class="form-control form-hanfa" placeholder="" value={getNFACommercialDetails?.orderValue?.excluding} name="orderValue.excluding" onChange={onDetailsInputChange} disabled={!isEditable} /></td>
                  </tr>

                  <tr>
                    <td>Benchmark Price/ Last Purchase Price Value</td>
                    <td><input type="number" class="form-control form-hanfa" placeholder="" name="benchmarkPrice.amount" value={getNFACommercialDetails?.benchmarkPrice?.amount} onChange={onDetailsInputChange}  disabled={!isEditable} /></td>

                    <Tooltip title={getNFACommercialDetails?.benchmarkPrice?.inWords}><td><input type="text" class="form-control form-hanfa" name="benchmarkPrice.inWords"
                     placeholder="" value={getNFACommercialDetails?.benchmarkPrice?.inWords}  onChange={onDetailsInputChange}   disabled={!isEditable} /></td></Tooltip>

                    <td><input type="text" class="form-control form-hanfa"  name="benchmarkPrice.excluding"
                      placeholder="" value={getNFACommercialDetails?.benchmarkPrice?.excluding} onChange={onDetailsInputChange}   disabled={!isEditable} /></td>
                  </tr>


                  <tr>
                    <td>Applicable Taxes & Duties</td>
                    <td><input type="text" class="form-control form-hanfa" name="applicableTaxes"   placeholder="" value={getNFACommercialDetails?.applicableTaxes}
                      onChange={onDetailsInputChange}  disabled={!isEditable} /></td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>Terms(EXW/ FOR/ FOB/ CIF)</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" value={getNFACommercialDetails?.terms}  name="terms" onChange={onDetailsInputChange}  disabled={!isEditable} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Delivery/ Completion  Period</td>  
                    <td><input type="date" class="form-control form-hanfa"  name="deliveryPeriod" onChange={onDetailsInputChange}    value={getNFACommercialDetails?.deliveryPeriod 
                    ? strToDateYYMMDD(getNFACommercialDetails.deliveryPeriod) 
                    : ""}   disabled={!isEditable} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Free Issue Materials</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="freeIssueMaterials" onChange={onDetailsInputChange} value={getNFACommercialDetails?.freeIssueMaterials}  disabled={!isEditable} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Payment terms</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="paymentTerms" onChange={onDetailsInputChange} value={getNFACommercialDetails?.paymentTerms}  disabled={!isEditable} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Whether LD applicable</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="ldApplicable" onChange={onDetailsInputChange} value={getNFACommercialDetails?.ldApplicable}  disabled={!isEditable} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Whether ABG, CPBG and PBG  applicable</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="bgApplicable" onChange={onDetailsInputChange} value={getNFACommercialDetails?.bgApplicable}  disabled={!isEditable} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Any Other Terms and Conditions</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="otherTnc" onChange={onDetailsInputChange} value={getNFACommercialDetails?.otherTnc}  disabled={!isEditable} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Any deviation from Standard Terms</td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="deviationFromTerms" onChange={onDetailsInputChange} value={getNFACommercialDetails?.deviationFromTerms}  disabled={!isEditable} /></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

            </div>

           <div className="maine_section_row">
           <div className="detail_bidding_nfa">
              <h5 className="detail_nfe">C. Background & Bid Details</h5>
            </div>
            { ((getNFACommercialDetails?.l1Approval?.approver === userID && getNFACommercialDetails?.l1Approval?.status === 'Pending') || (getNFACommercialDetails?.l2Approval?.approver === userID && getNFACommercialDetails?.l2Approval?.status === 'Pending')) && (
              <div className="edit_button" onClick={handleEditBackgroundClick}>
                  <EditOutlinedIcon className="edit_button_icon"/> Edit
              </div>
            )}
           </div>

           <Editor
              editorState={backgroundBidDetails?.backgroundAndBidDetails}
              toolbarClassName="toolbarClassName"
              readOnly={
                (getNFACommercialDetails?.l1Approval?.approver !== userID && 
                getNFACommercialDetails?.l2Approval?.approver !== userID) ? 
                  !isEditable : 
                  !isEditorEditable
              }   
              toolbarHidden={
                (getNFACommercialDetails?.l1Approval?.approver !== userID && 
                getNFACommercialDetails?.l2Approval?.approver !== userID) ? 
                  !isEditable : 
                  !isEditorEditable
              }  
              // editorClassName={`editorClassName ${!isEditable ? 'editorDisabled' : ''}`}  
              // editorClassName={`${!isEditable ? 'editorDisabled' : isEditorEditClass}`}  
              wrapperClassName="wrapperClassName"
              onEditorStateChange={onEditorStateChangeOne}
            />

              {showButtons  && (
                <div class="all_btn_nfa">
                  <button
                    type="button"
                    class="btn btn btn-danger"
                    onClick={handleCancelBackgroundClick}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="btn btn-success"
                    onClick={() => {
                        // props?.setOpenNfaApprovelModal(false);
                        // setOpenNfaApprovelModalSubmit(true);
                        updateBidDetails("bid");
                    }}
                  >
                    Update
                  </button>
                </div>
              )}


             <div className="detail_bidding_nfa">
                  <h5 className="detail_nfe">D. Comparison of Bids</h5>
            </div>
            <div className="listing_main listing_main_dragdropcontext_body comparsion_bidding_table">
                <table>
                    <thead> 
                      <tr>
                        {comparisonColumns.map((comparisonColumns, index) => (<>
                          <th className="vendor_tabels ">
                            <div className="PoDetailTableHeading">
                              <div className="d-flex">
                                <p>{comparisonColumns?.label}</p>
                                {(comparisonColumns.isSort == true) && <span onClick={(e) => onSortChange(index, comparisonColumns.id, comparisonColumns.sortLabel)} className="table-sort-ico">
                                  {(comparisonColumns.sortLabel != "asc") && <img src={topArrow} />}
                                  {(comparisonColumns.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                  {(comparisonColumns.sortLabel != "desc") && <img src={bottomArrow} />}
                                  {(comparisonColumns.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                </span>}
                              </div>
                            </div>
                          </th>
                        </>))}
                      </tr>
                    </thead>
                    <tbody>
                       {getNFACommercialDetails.length < 1 && <>
                            <tr>
                              <td colSpan={8} className="text-center list-no-data">No Data Found</td>
                            </tr>
                          </>}
                          {getNFACommercialDetails?.rfqVendors?.map((vendorData, i) => (<>
                            <tr className="maine_tr_vendor">
                              <td>{i+1}</td>
                              <td>{vendorData?.vendorName}</td>
                              <td>{vendorData?.vendorCode}</td> 
                              <td>{(vendorData?.rank) ? `L${vendorData?.rank}`:''}</td> 
                              <td>{vendorData?.technicalStatus}</td> 
                              <td>{vendorData?.boqs[0]?.totalAmount}</td>
                              <td> {vendorData?.vendorData[1]?.totalAmount 
                                  ? `${vendorData.vendorData[1].totalAmount}` 
                                  : "N/A"}</td>
                              
                             <td> 
                             <input type="text" class="form-control form-hanfa" placeholder="" name="finalNegotiatedAmount" value={vendorData?.finalNegotiatedAmount} onChange={(e) =>calculatePercentageDifference(vendorData?.vendorId , e.target.value,vendorData?.boqs[0]?.totalAmount)}  disabled={!isEditable} />
                             </td>
                             {/* <td>${
                                ((vendorData?.finalNegotiatedAmount -
                                  vendorData?.boqs[0]?.totalAmount) *
                                  100) /
                                  vendorData?.boqs[0]?.totalAmount
                              } %</td> */}
                              <td>{vendorData?.reduction} %</td>
                            </tr>
                          </>))}  
                    </tbody>
                </table>
            </div>

            <div className="listing_main listing_main_dragdropcontext_body table_bidding">
              <table>
                <thead>
                    <tr>
                        <th>Budget Head</th>
                        <th>Budget Amount</th>
                        <th>This Proposal</th>
                        <th>Balance/ Additional Budget Required</th>
                        <th>Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="budgetHead" value={getNFACommercialDetails?.budgetHead} onChange={onDetailsInputChange}  disabled={!isEditable} /></td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="budgetAmount" value={getNFACommercialDetails?.budgetAmount} onChange={onDetailsInputChange}  disabled={!isEditable} /></td>
                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="thisProposal" value={getNFACommercialDetails?.thisProposal} onChange={onDetailsInputChange}  disabled={!isEditable} /></td>

                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="balanceBudget" value={getNFACommercialDetails?.balanceBudget} onChange={onDetailsInputChange}  disabled={!isEditable} /></td>

                    <td><input type="text" class="form-control form-hanfa" placeholder="" name="remarks" value={getNFACommercialDetails?.remarks}  disabled={!isEditable} onChange={onDetailsInputChange} /></td>
                    </tr>
                </tbody>
              </table> 
            </div>

            <div className="maine_section_row">
              <div className="detail_bidding_nfa">
                 <h5 className="detail_nfe">Recommendation</h5>
                </div>
                { ((getNFACommercialDetails?.l1Approval?.approver === userID && getNFACommercialDetails?.l1Approval?.status === 'Pending') || (getNFACommercialDetails?.l2Approval?.approver === userID && getNFACommercialDetails?.l2Approval?.status === 'Pending')) && (
                  <div className="edit_button"  onClick={handleEditBackgroundClick1}>
                    <EditOutlinedIcon className="edit_button_icon"/> Edit
                </div>
                )}
           </div>
            <Editor
              editorState={recommendationDetials?.recommendation}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              readOnly={
                (getNFACommercialDetails?.l1Approval?.approver !== userID && 
                getNFACommercialDetails?.l2Approval?.approver !== userID) ? 
                  !isEditable : 
                  !isEditorEditable1
              }   
              toolbarHidden={
                (getNFACommercialDetails?.l1Approval?.approver !== userID && 
                getNFACommercialDetails?.l2Approval?.approver !== userID) ? 
                  !isEditable : 
                  !isEditorEditable1
              }  
              
              //  editorClassName={`${!isEditable ? 'editorDisabled' : isEditorEditClass}`}  
              //editorClassName={`${isEditorEditClass ? isEditorEditClass : !isEditorEditable1}`} 
              onEditorStateChange={onEditorStateChangeTwo}
              disabled={!isEditable}
          /> 
          </div>            
              </div> 

              {showRecomButtons && (
                <div class="all_btn_nfa">
                    <button
                      type="button"
                      class="btn btn btn-danger"
                      onClick={handleCancelRecomdationClick}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      class="btn btn-success"
                      onClick={() =>  updateBidDetails("reco")}
                    >
                      Update
                    </button>
                </div>
              )}

          {isEditable && userRole === "BUYER" && (
           <div className="submit_btn_forn_qccreation" >  
              <button
                      type="button"
                      class="btn btn-danger"
                      onClick={()=>redirectList()}
                    >
                      Cancel
                    </button>
              <button  type="button"  class="btn btn-success save_next_btns"  
              //  onClick={handleSubmit}
              onClick={() => { 
                setOpenNfaApprovelModalUpdate(true);
            }}
               >
                Submit
              </button>
            </div>
          )}

          {/*NFA Modal Submit */}
          <Modal
            open={opennfaapprovelmodalupdate}
            onClose={() => setOpenNfaApprovelModalUpdate(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenNfaApprovelModalUpdate(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p>
                Are you sure you want to Update the <b>NFA</b>?
                </p>
                <div class="lets_no_btn_danger_yes_technical_project">
                  <button
                    type="button"
                    class="btn btn btn-danger"
                    onClick={() => {
                      setOpenNfaApprovelModalUpdate(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="btn btn-success"
                    onClick={() => {
                      setOpenNfaApprovelModalUpdate(false);
                      // setOpenNfaApprovelsuccessNfa(true);
                      handleSubmit();
                    }}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

             {/*NFA Modal Successfully */}
        <Modal
            open={opennfaapprovelsuccessnfa}
            onClose={() => setOpenNfaApprovelsuccessNfa(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenNfaApprovelsuccessNfa(false)}
                ></button>
              </div>
              <div class="modal-bodys">
              <img src={checkImage} alt="" />
                <p>
                <b>NFA</b> has been successcfully updated.
                </p>
                <div class="lets_no_btn_danger_yes_technical_project">
                  <button
                    type="button"
                    class="btn btn-success"
                    onClick={() => {
                      // setOpenNfaApprovelsuccessNfa(false);
                      // navigateUrl("admin/Engineering-Bidding-Rfq-Listing"); 
                      redirNFA();
                    }}


                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>


          {/*NFA Approved Modal */}
          <Modal
            open={openapprovednfa}
            onClose={() => setOpenApprovedNfa(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenApprovedNfa(false)}
                ></button>
              </div>
              <div class="modal-body">
                <p className="approval_NFAtecnoda">
                Are you sure you want to Approve <b>NFA?</b>
                </p>
                <div className="lets_vendor_lr_details_block_asn_react_body_block ">
                    <div className="required_react_vendor_block">
                      <label className="nfaApprovalText">
                        Please Enter Remarks:
                      </label> 
                      <div className="lets_asn_block_body_required_number"> 
                        <textarea
                          type="text"
                          className="form-control vendorNFA_approval"
                          name="remarks" 
                          value={remarks}
                          onChange={handleRemarksChange}
                        /> 
                      </div>
                    </div>
                  </div>
                <div class="lets_no_btn_danger_yes_technical_project">
                  <button
                    type="button"
                    class="btn btn-success"
                    onClick={() => {
                      setOpenApprovedNfa(false);
                      handleApproveSubmit("Approve");
                      //setOpenApprovedSuccessNfa(true);
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    class="btn btn btn-danger"
                    onClick={() => {
                      setOpenApprovedNfa(false);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
                 </Modal>

             {/*NFA Approved successfully Modal */}
             <Modal
            open={openapprovedsuccessnfa}
            onClose={() => setOpenApprovedSuccessNfa(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenApprovedSuccessNfa(false)}
                ></button>
              </div>
              <div class="modal-bodys">
              <img src={checkImage} alt="" />
                <p>
                Congratulations <b>NFA</b> has been <b>{actionStatus}</b> Successfully
                </p>
                <div class="lets_no_btn_danger_yes_technical_project">
                  <button
                    type="button"
                    class="btn btn-success"
                    onClick={() => {
                      setOpenApprovedSuccessNfa(false);
                      navigateUrl('/admin/Engineering-Bidding-Rfq-Listing'); 
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>


        {/*NFA Rejected Modal */}
        <Modal
            open={openrejectednfa}
            onClose={() => setOpenRejectedNfa(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenRejectedNfa(false)}
                ></button>
              </div>
              <div class="modal-body">
                <p className="approval_NFAtecnoda">
                Are you sure you want to Rejected <b>NFA?</b>
                </p>
                <div className="lets_vendor_lr_details_block_asn_react_body_block ">
                    <div className="required_react_vendor_block">
                      <label className="label_react_block_body_asn">
                        Please Enter Remarks:
                      </label> 
                      <div className="lets_asn_block_body_required_number"> 
                        <textarea
                          type="text"
                          className="form-control vendorNFA_approval"
                          name="remarks" 
                          value={remarks}
                          onChange={handleRemarksChange}
                        /> 
                      </div>
                    </div>
                  </div>
                <div class="lets_no_btn_danger_yes_technical_project">
                  <button
                    type="button"
                    class="btn btn-success"
                    onClick={() => {
                      setOpenRejectedNfa(false);
                      handleApproveSubmit("Reject");
                      // setOpenRejectedNfaSuccess(true);
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    class="btn btn btn-danger"
                    onClick={() => {
                      setOpenRejectedNfa(false);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
                 </Modal>


                    {/*NFA Rejected successfully Modal */}
             <Modal
            open={openrejectednfasuccess}
            onClose={() => setOpenRejectedNfaSuccess(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenRejectedNfaSuccess(false)}
                ></button>
              </div>
              <div class="modal-bodys">
              <img src={rejectImage} alt="" />
                <p>
                 <b>NFA</b> has been <b>Rejected</b> Successfully
                </p>
                <div class="lets_no_btn_danger_yes_technical_project">
                  <button
                    type="button"
                    class="btn btn-success"
                    onClick={() => {
                      setOpenRejectedNfaSuccess(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
     </div>
     </div>

  
     <AlertComponent
              alertComponent={alertComponent}
              handleClose={handleCloseAlert}
            />
            <Backdrop
              sx={{
                color: "#fff",
                zIndex: (theme) => 99999,
              }}
              open={isLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
  
  
  </>
  )
}

export default ApprovalNFA